import QueryContext from '../QueryContext';
import api from '../index';

const planFetchers = {
  plans: (context: QueryContext) =>
    api.get('/plans', {params: {include: ['features']}}),
};

export default planFetchers;
